import { Component, Input, OnInit } from "@angular/core";
import { formatDate } from "@angular/common";
import {
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { ModalController } from "@ionic/angular";
import { AutoCheckoutService } from "src/app/services/auto-checkout/auto-checkout.service";

@Component({
  selector: "app-autocheckout-form",
  templateUrl: "./autocheckout-form.component.html",
  styleUrls: ["./autocheckout-form.component.scss"],
})
export class AutocheckoutFormComponent implements OnInit {
  @Input() storeId: string;
  form_data: any[];
  private questionSet: any;
  public validBdate: any;

  formFields: any[];
  public formQuestionData: boolean = true;
  public minPickupDate: any;

  form = new FormGroup({});

  constructor(
    private autoCheckoutService: AutoCheckoutService,
    private modalController: ModalController
  ) {}

  ngOnInit() {
    this.form_data = [];
    this.questionSet = [];
    const currentDate = new Date();
    const currentBdate = new Date();
    const numberOfDaysToAdd = 2;
    this.minPickupDate = formatDate(
      currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd),
      "yyyy-MM-dd",
      "en-US"
    );
    const numberOfYearToSubstract = 18;
    this.validBdate = formatDate(
      currentBdate.setFullYear(
        currentBdate.getFullYear() - numberOfYearToSubstract
      ),
      'yyyy-MM-dd',
      'en-US'
    );
  }

  closeModal() {
    // this.airportListService.setSelectedAirport(selectedAirport.airportCode);
    this.modalController.dismiss();
  }

  ionViewDidEnter() {
    this.autoCheckoutService
      .getAutoCheckoutForm(this.storeId)
      .subscribe((response) => {
        if (response.questions && response.questions.length > 0) {
          this.form_data = response.questions;

          for (const formField of this.form_data) {
            this.form.addControl(formField.name, this.getValidator(formField));
            this.questionSet[formField.name] = [];
            this.questionSet[formField.name]["label"] = formField.question;
            this.questionSet[formField.name]["id"] = formField.id;
          }
          this.formFields = this.form_data;
        } else {
          this.formQuestionData = false;
        }
      });
  }

  private getValidator(formField: any): any {
    switch (formField.name) {
      case "email":
        return new FormControl("", [Validators.required, Validators.email]);
      case "phone_number":
        return new FormControl("", [
          Validators.required,
          Validators.pattern("^[0-9]{10}$"),
        ]);
      default:
        return new FormControl("", [Validators.required]);
    }
  }

  submitRequest() {
    let requestData = [];

    Object.keys(this.form.value).forEach((key) => {
      requestData.push({
        answer: this.form.value[key],
        question: this.questionSet[key]["label"],
        questionId: this.questionSet[key]["id"],
      });
    });

    this.modalController.dismiss({
      formInfo: requestData,
    });
  }
}
